import React, { useState } from "react";
import Confetti from "react-confetti-boom";
import { Button } from "../../atoms";
import styles from "./modal-winner.module.css";

const ModalWinner = ({ prize, onClose }) => {
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    setTimeout(onClose, 500);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm z-[200]">
      <Confetti className="z-[999]" particleCount={100} y={1} shapeSize={15} launchSpeed={2.5} />
      {/* Contenido del modal */}
      <div
        className={`
          ${styles.modalContent} text-center shadow-2xl bg-white rounded-[32px] flex flex-col items-center justify-center gap-8
          ${closing ? "animate-fade-out-bottom" : "animate-fade-in-bottom"}
        `}
      >
        <span className={`${styles.modalTextTitle} font-bold font-mont`}>FELICIDADES!</span>
        <span className={`${styles.modalText} font-medium text-blue-600 font-montserrat`}>Ganaste un:</span>
        <span className={`${styles.modalTextTitle} font-extrabold uppercase`}>{prize}</span>
        <Button onClick={handleClose}>Aceptar</Button>
      </div>
    </div>
  );
};

export default ModalWinner;
